import { lazy } from "react";

export const CodeBlockCodeMirrorView = lazy(() =>
  import("./CodeBlockCodeMirrorView").then((module) => ({
    default: module.CodeBlockCodeMirrorView,
  })),
);
